import { Injectable, EventEmitter, OnInit } from "@angular/core";
// import { Observable } from 'rxjs/Rx';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from "@angular/router";

// Services
import * as srv from "../share/services";
import { IContact } from "../share/interfaces/index";
import { retry } from "rxjs/operators/retry";

@Injectable()
export class ActivateLogin implements CanActivate {
	name = "ActivateLogin";
	constructor(
		private _userSrv: srv.UserService,
		private _helperSrv: srv.HelperService,
		private _ssoSrv: srv.SsoService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean> | boolean {
		// console.log(this.name, this._helperSrv.env, this._userSrv.getContact(), this._userSrv.Data, this._ssoSrv.DATA);
		// return true;
		if (this._userSrv.getContact() === undefined) {
			console.log(
				"called inside canactivate on login.activate and getcontact is undefined"
			);
			const env = this._helperSrv.env;
			if (env === "development") {
				return true;
			} else {
				"redirect to login page".logWithObject(
					"ActivateLogin",
					state.url
				);
				this._ssoSrv.GetSSO("A00000").then(context => {
					if (context === undefined) {
						this._ssoSrv.login(state.url);
					} else {
						this._ssoSrv.GetContext("A00000").then(c => {
							this._userSrv.CURRENTUSER_CONTACTID = this._ssoSrv.DATA.contactid;
							this._userSrv.CURRENTUSER_ACEPID = this._ssoSrv.DATA.acepid;
							this._userSrv.CURRENTUSER_FIRSTNAME = this._ssoSrv.DATA.firstname;

							this._helperSrv.goToApplications(
								this._ssoSrv.DATA.acepid
							);

							// this._userSrv
							// 	.getContactFromCRM(c.user.ContactNumber)
							// 	.then(contact => {
							// 		this._userSrv.setContact(
							// 			"",
							// 			contact,
							// 			this._ssoSrv.DATA.avatar
							// 		);
							// 		//NH - 1/22/18 - going to the application page on login, not the main page.
							// 		//this._helperSrv.goToMain();
							// 		this._helperSrv.goToApplications(
							// 			this._userSrv.getContact().AcepId
							// 		);
							// 		return true;
							// 	});
						});
					}
				});
				return false;
				// return true;
			}
		} else {
			console.log(
				"activated and no getcontact: " + this.name,
				this._userSrv.getContact()
			);

			let c: IContact = this._userSrv.getContact();

			this._userSrv.CURRENTUSER_CONTACTID = this._ssoSrv.DATA.contactid =
				c.Id;
			this._userSrv.CURRENTUSER_ACEPID = this._ssoSrv.DATA.acepid =
				c.AcepId;
			this._userSrv.CURRENTUSER_FIRSTNAME = this._ssoSrv.DATA.firstname =
				c.Profile.FirstName;

			//NH 1/22/18 - Go to the applications page when logging in.
			//this._helperSrv.goToMain();
			this._helperSrv.goToApplications(this._ssoSrv.DATA.acepid);
			return true;
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/activates/login.activate.ts